import React, { useEffect, useState } from 'react';
import { ReactComponent as Pencil } from 'assets/icons/pencil.svg';
import { Modal } from 'components';
import { Input } from 'antd';
import { Select } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { clearGroupsPrivileges, cleargroupGroups, getGroupById, getGroupData, getGroups, getPrivileges, getPrivilegesByGroup, getgroupData, updateGroupPrivileges, updategroup, updategroupGroup } from 'store/adminPanel/actions';

const EditModal = ({ isVisible, setVisible, groupId, setEditedPriv }) => {
    const dispatch = useDispatch();

    const group = useSelector((state => state.adminPanel.selectedGroup));
    const [groupID, setGroupID] = useState(group?.id);
    const [groupName, setGroupName] = useState(group?.name);
    const [groupType, setGroupType] = useState(group?.type);
    // const [groupGroup, setgroupGroup] = useState(group ? group.groups ? group.groups.map(item=>item.name) : "" : "");
    const [groupPrivileges, setGroupPrivileges] = useState([]);
    const [intiGroupPrivileges, setInitGroupPrivileges] = useState([]);
    const [edited, setEdited] = useState(false);
    const [privileges, setPrivileges] = useState([]);

    useEffect(() => {
        if(groupId){
            dispatch(getGroupData(groupId));
        }
    }, [groupId, edited]);

    useEffect(()=>{
        if(groupID){
            getPrivilegesByGroup(
                groupID,
                callback => {
                    if(callback){
                        // console.log("callback:",callback.map(item=>item.name));
                        setGroupPrivileges(callback.map(item=>item.name));
                        setInitGroupPrivileges(callback.map(item=>item.name));
                    }
                }
            )
        }
    },[groupID])

    useEffect(()=>{
        getPrivileges().then(privileges => {
            setPrivileges(privileges.map(item=>item.name));
            }).catch(error => {
            console.error("Error fetching privileges:", error);
            });
    },[]);

    // console.log("privileges:",privileges);

    useEffect(()=>{
        setGroupID(group?.id);
        setGroupName(group?.name);
        setGroupType(group?.type);
        // setGroupPrivileges()
        setEdited(false);
    },[group, edited]);

    const handleOk = () => {
        clearGroupsPrivileges(groupID, intiGroupPrivileges)
        .then(() => {
            return updateGroupPrivileges(groupID, groupPrivileges, 
                callback => {
                    if(callback){
                        setEditedPriv(true);
                    }
                }
            )
            // .then(()=>{
            //     setEditedPriv(true);
            // })
        })
        setVisible(false);
    }

    return (
      <Modal
        isVisible={isVisible}
        Icon={Pencil}
        onCancel={() => setVisible(false)}
        onOk={()=> handleOk()}
        title={<h1 style={{color:"#2d97e9", marginTop:"0.563rem", marginLeft:"1.875rem"}}>Edit group</h1>}
        width={817}
        okText="Edit group"
      >
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Group ID</span>
            <Input style={{height:"40px"}} value={groupID}></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Name</span>
            <Input style={{height:"40px"}} value={groupName}></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Type</span>
            <Input style={{height:"40px"}} value={groupType}></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Group</span>
            <Select
            showSearch={false}
            size="small"
            mode="multiple"
            value={groupPrivileges}
            placeholder="Select a group"
            onChange={value => setGroupPrivileges(value)} 
            options={privileges.map(item => ({
                label: item,
                value: item
            }))}
        />
        </div>
      </Modal>
    );
  };
  
  export default EditModal;